import SelectSearch, {
  fuzzySearch,
  SelectedOptionValue,
  SelectedOption,
  SelectSearchOption,
  SelectSearchProps,
} from 'react-select-search';
import { Flex } from 'reflexbox';
import { useStateVar } from 'helpers/useStateVar';
import { colors } from '~/styles/colors';
import { SingleDatePicker } from 'react-dates';
import moment, { Moment } from 'moment';

import {
  SearchInput,
  Label,
  ControlFilter,
  CleanBtn,
  FiltersContainer,
  ContainerArea,
  LoadingContainer,
  ContentDate,
  DateLabel,
  StyledCalendarIcon,
  SearchInputDevice,
} from './styles';
import i18n from '~/i18n';
import { Button, HealthIcon, Loader } from '~/components';
import { ToggleSwitchMini } from '~/components/ToggleSwitch';
import { WithContext as ReactTags } from 'react-tag-input';
import {
  ClipboardEvent,
  ReactNode,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { FilterIcon, SearchIcon } from '~/icons';
import { getUserProfile } from '~/helpers/userProfile';
import { ChevronDownIcon, ChevronUpIcon } from '@radix-ui/react-icons';
import {
  getAllFaults,
  getClientsList,
  getListDevicesByType,
  getMachinesList, getUnitsList,
} from '~/helpers/genericHelper';
import { FaultState } from '~/providers/types/api-private';
import { formatPhone } from '~/helpers/formatPhone';
import { apiCall } from '~/providers';
import { IconWrapperSearch } from '../EnvGroupAnalysis/styles';

const t = i18n.t.bind(i18n);

export type TListFilters = 'cliente' | 'unidade' | 'saude' | 'deviceId' | 'machines' | 'criticidadeAtual' | 'falhasDetectadas' | 'criticidadeFalhaDetectada' | 'primeiroAlertaDe' | 'primeiroAlertaAte' | 'ultimaDeteccaoDe' | 'ultimaDeteccaoAte' | 'status' | 'users' | 'phone' | 'contestation' | 'statusHealth' | 'maintenance' | 'maintenanceDate';

type TValueFilter = string | string[];

export const FilterFaults = (props:{
  state: any,
  onAply: () => void, // funçao para quando mudar o valor do select;
  listFilters?: TListFilters[], // passar os selects que é pra ter;
  deviceType: 'dac' | 'dut' | undefined,
  updateInfos: (topic: string, newValues?: [], dates?: Moment | null, option?: boolean, valueNumber?: string) => void;
}): JSX.Element => {
  const [state, render, setState] = useStateVar(() => {
    const state = {
      // Filtros globais
      isLoading: false, // setIsLoading
      selectedDateStartFirstAlert: null as Moment | null,
      selectedDateEndFirstAlert: null as Moment | null,
      selectedDateStartLastAlert: null as Moment | null,
      selectedDateEndLastAlert: null as Moment | null,
      selectFocusedFirstAlert: false,
      selectFocusedEndFirstAlert: false,
      selectFocusedStartLastAlert: false,
      selectFocusedEndLastAlert: false,
      tomorrow: moment(moment().add(1, 'days').format('YYYY-MM-DD')),
      showFilter: true as boolean,
      clientsListOpts: [] as { value: string, name: string, cities: string[], states: number[] }[],
      selectedClientOpts: [] as TValueFilter,
      unitsFilterOpts: [] as { value: string, name: string, clientId: number }[],
      machinesFilterOpts: [] as { value: string, name: string, clientId: number }[],
      unitsListOpts: [] as { value: string, name: string, clientId: number }[],
      machinesListOpts: [] as { value: string, name: string, clientId: number }[],
      faultsListOpts: [] as { value: string, name: string }[],
      selectedFaultsOpts: [] as TValueFilter,
      devicesFilterOpts: [] as { value: string, name: string, clientId: number, unitId: number }[],
      devicesListOpts: [] as { value: string, name: string, clientId: number, unitId: number }[],
      selectedDevicesOpts: [] as TValueFilter,
      selectedUnitOpts: [] as TValueFilter,
      selectedMachinesIds: [] as TValueFilter,
      selectedHealthOpts: [] as TValueFilter,
      selectedFaultsDetected: [] as TValueFilter,
      selectedOnlyFaultsDetectedInAllCycles: false as boolean,
      selectedFaultCriticality: [] as TValueFilter,
      selectedFaultStates: ['PENDING', 'RESTAB_PENDING'] as FaultState[],
      focused: {} as {
        id: string,
        focused: boolean,
      },
      isClearFilter: false as boolean,
      finalizedInputs: false as boolean,
      // Filtros da tela de feedback do mantenedor
      usersFilterOpts: [] as { value: string, name: string }[],
      selectedUsers: [] as TValueFilter,
      selectedPhone: '',
      selectedDateContestation: null as Moment | null,
      selectFocusedDateContestation: false,
      selectedStatusHealth: [] as TValueFilter,
      selectedMaintenance: [] as TValueFilter,
      selectedDateMaintenance: null as Moment | null,
      selectFocusedDateMaintenance: false,
      searchState: [] as { text: string }[],
    };
    return state;
  });
  const [profile] = useState(getUserProfile);

  function setValues() {
    props.updateInfos('client', state.selectedClientOpts as []);
    props.updateInfos('unit', state.selectedUnitOpts as []);
    props.updateInfos('machines', state.selectedMachinesIds as []);
    props.updateInfos('devices', state.searchState.map((item) => item.text) as []);
    props.updateInfos('health', state.selectedHealthOpts as []);
    props.updateInfos('currentHealthCriticality', state.selectedFaultsOpts as []);
    props.updateInfos('faultsDetected', state.selectedFaultsDetected as []);
    props.updateInfos('onlyFaultsDetectedInAllCycles', undefined, undefined, state.selectedOnlyFaultsDetectedInAllCycles);
    props.updateInfos('detectedFaultCriticality', state.selectedFaultCriticality as []);
    props.updateInfos('dateStartFirstAlert', undefined, state.selectedDateStartFirstAlert);
    props.updateInfos('dateEndFirstAlert', undefined, state.selectedDateEndFirstAlert);
    props.updateInfos('dateStartLastAlert', undefined, state.selectedDateStartLastAlert);
    props.updateInfos('dateEndLastAlert', undefined, state.selectedDateEndLastAlert);
    props.updateInfos('faultStates', state.selectedFaultStates as []);
    props.updateInfos('users', state.selectedUsers as []);
    props.updateInfos('phone', undefined, undefined, undefined, state.selectedPhone);
    props.updateInfos('contestation', undefined, state.selectedDateContestation);
    props.updateInfos('statusHealth', state.selectedStatusHealth as []);
    props.updateInfos('maintenance', state.selectedMaintenance as []);
    props.updateInfos('maintenanceDate', undefined, state.selectedDateMaintenance);
  }

  function clearFilters() {
    state.isClearFilter = true;

    removeAllFilters();
    setState({
      unitsFilterOpts: state.unitsListOpts,
      devicesFilterOpts: state.devicesListOpts,
    });
    setValues();
    render();
    sessionStorage.clear();
    props.state.needFilter = null;
    state.isLoading = false;
  }

  async function getFiltersData() {
    if (props.listFilters?.includes('cliente') && profile.manageAllClients) {
      await getClientsList(state, render);
    }
    if (props.listFilters?.includes('unidade')) {
      await getUnitsList(state, render);
      setState({ unitsFilterOpts: state.unitsListOpts });
    }
    if (props.listFilters?.includes('criticidadeAtual')) {
      setState({
        faultsListOpts: await getAllFaults(),
      });
    }
    if (props.listFilters?.includes('deviceId')) {
      await getListDevicesByType(state, render, props.deviceType);
      setState({ devicesFilterOpts: state.devicesListOpts });
    }
    if (props.listFilters?.includes('users')) {
      const { list } = await apiCall('/users/list-users', {});
      setState({ usersFilterOpts: list.map((user) => ({ value: user.USER, name: user.NOME })) });
    }
  }

  async function getMachineData() {
    if (props.listFilters?.includes('machines')) {
      await getMachinesList(state, render);
      setState({ machinesFilterOpts: state.machinesListOpts });
    }
  }

  useEffect(() => {
    setState({
      finalizedInputs: true,
    });
    getFiltersData();
  }, []);

  useEffect(() => {
    getMachineData();
  }, [state.selectedClientOpts, state.selectedUnitOpts]);

  useEffect(() => {
    // TODO: remove this once there is an actual Machine Fault implemented
    // this is just a workaround so that the R&D team can filter manual faults that affect all cycles in the machine
    // since we already have faults that should only be detected if they are detected in ALL cycles of the machine
    // but faults are detected by asset of a machine (i.e. we still don't have a proper Machine Fault implementation)
    // this boolean is used in conjunction with filters.faultsDetected to fetch specific faults that affect all cycles of a machine
    if ((state.selectedFaultsDetected?.length ?? 0) === 0 && state.selectedOnlyFaultsDetectedInAllCycles) {
      // if there are no faults selected in selectedFaultsDetected, and selectOnlyFaultsDetectedInAllCycles is true, set it back to false forcibly
      // selectOnlyFaultsDetectedInAllCycles can only be true if there is at least one element in the selectedFaultsDetected array
      // the toggle that changes this flag only renders if there is at least one element in the array
      // if the toggle is de-rendered (the array has been changed to have 0 elements) while the flag is set to true, this useEffect corrects it to false
      setState({ selectedOnlyFaultsDetectedInAllCycles: false });
    }
  }, [state.selectedFaultsDetected]);

  function onChangeClient(clients) {
    const filteredArray = clients.filter((value) => !state.selectedClientOpts.includes(value));
    if (filteredArray?.length) {
      const selectedClients = [...state.selectedClientOpts, ...filteredArray];
      onChangeClientAux(selectedClients);
    } else {
      onChangeClientAux(clients);
    }

    render();
  }

  function onChangeMachines(machines) {
    setState({ selectedMachinesIds: machines });
    render();
  }

  function onChangeClientAux(selectedValues) {
    const filteredUnits = state.unitsListOpts.filter((unit) => {
      const isClientMatching = !selectedValues?.length || selectedValues.includes(unit.clientId.toString());
      return isClientMatching;
    });

    const filteredDevices = state.devicesListOpts.filter((device) => {
      const isClientMatching = !selectedValues?.length || selectedValues.includes(device.clientId.toString());
      return isClientMatching;
    });

    setState({
      selectedUnitOpts: [],
      unitsFilterOpts: filteredUnits,
      selectedDevicesOpts: [],
      devicesFilterOpts: filteredDevices,
      selectedClientOpts: selectedValues,
    });
  }

  function onChangeUnit(units) {
    const filteredArray = units.filter((value) => !state.selectedUnitOpts.includes(value));
    if (filteredArray?.length) {
      setState({
        selectedUnitOpts: [...state.selectedUnitOpts, ...filteredArray],
      });
    } else {
      setState({
        selectedUnitOpts: units,
        unitsFilterOpts: state.unitsListOpts,
        devicesFilterOpts: state.devicesListOpts,
      });
    }

    const filteredUnits = state.unitsListOpts.filter((unit) => {
      const isClientMatching = !state.selectedClientOpts?.length || state.selectedClientOpts.includes(unit.clientId.toString());
      return isClientMatching;
    });

    setState({
      unitsFilterOpts: filteredUnits,
    });

    onChangeUnitAux(state.selectedUnitOpts);

    render();
  }

  function onChangeUnitAux(selectedValues) {
    if (!selectedValues?.length) {
      const filteredDevices = state.devicesListOpts.filter((device) => {
        const isClientMatching = !state.selectedClientOpts?.length || state.selectedClientOpts?.includes(device.clientId.toString());
        return isClientMatching;
      });

      setState({
        devicesFilterOpts: filteredDevices,
      });

      render();
    } else {
      const filteredDevices = state.devicesListOpts.filter((device) => {
        const isUnitMatching = !selectedValues?.length || selectedValues.includes(device.unitId.toString());
        return isUnitMatching;
      });

      setState({
        devicesFilterOpts: filteredDevices,
      });

      render();
    }
  }

  function removeAllFilters() {
    setState({
      selectedClientOpts: [],
      selectedMachinesIds: [],
      selectedUnitOpts: [],
      machinesFilterOpts: state.machinesListOpts,
      unitsFilterOpts: state.unitsListOpts,
      selectedDevicesOpts: [],
      devicesFilterOpts: state.devicesListOpts,
      selectedHealthOpts: [],
      selectedFaultsDetected: [],
      selectedFaultsOpts: [],
      selectedFaultCriticality: [],
      selectedDateStartFirstAlert: null,
      selectedDateEndFirstAlert: null,
      selectedDateStartLastAlert: null,
      selectedDateEndLastAlert: null,
      selectedFaultStates: [],
      selectedUsers: [],
      selectedPhone: '',
      selectedDateContestation: null,
      selectedStatusHealth: [],
      selectedMaintenance: undefined,
      selectedDateMaintenance: null,
    });
    props.onAply();
  }

  const loading = false;
  const KeyCodes = {
    comma: 188,
    slash: 191,
    enter: [10, 13],
  };

  const delimiters = [...KeyCodes.enter, KeyCodes.comma, KeyCodes.slash];

  const handleSearchDelete = useCallback((i: number) => {
    setState({
      searchState: state.searchState.filter((_, index) => index !== i),
    });
  }, []);

  const handleSearchAddition = useCallback((tag: { text: string }) => {
    setState({
      searchState: [...state.searchState, tag],
    });
  }, []);
  return (
    <Flex style={{ position: 'relative' }} flexDirection="column">
      <div style={{ display: 'flex', alignItems: 'center', margin: '10px 0px' }}>
        <ControlFilter onClick={() => { state.showFilter = !state.showFilter; render(); }}>
          <FilterIcon />
          {t('filtros')}
          {state.showFilter ? <ChevronUpIcon width={20} color={colors.BlueSecondary} /> : <ChevronDownIcon width={20} color={colors.BlueSecondary} />}
        </ControlFilter>
        <div>
          <CleanBtn onClick={() => { clearFilters(); props.onAply(); }}>
            {t('limparFiltros')}
          </CleanBtn>
        </div>
      </div>
      { state.finalizedInputs ? (
        <FiltersContainer
          flexWrap={['wrap', 'wrap', 'wrap', 'nowrap', 'nowrap']}
          showFilter={state.showFilter}
          style={{ position: 'relative' }}
        >
          {
            state.showFilter && (
              <Flex
                flexDirection="row"
                justifyContent="center"
                mt={state.showFilter ? 0 : -23}
                alignItems="flex-start"
                style={{
                  transition: 'visibility 0.5s, opacity 0.5s, background-color 0.5s, margin-top 1s',
                  visibility: state.showFilter ? 'visible' : 'hidden',
                  opacity: state.showFilter ? '1' : '0',
                }}
                flexWrap={['wrap', 'wrap', 'wrap', 'wrap', 'nowrap']}
              >
                <div style={{
                  width: '100%',
                }}
                >
                  <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '5px',
                  }}
                  >
                    {
                      props.listFilters?.includes('cliente') && (
                        <FilterOption
                          options={state.clientsListOpts}
                          value={state.selectedClientOpts}
                          onChange={(value) => { onChangeClient(value); }}
                          multiple
                          placeholder={t('cliente')}
                          disabled={loading}
                        />
                      )
                    }
                    {
                      props.listFilters?.includes('unidade') && (
                        <FilterOption
                          value={state.selectedUnitOpts}
                          options={state.unitsFilterOpts}
                          onChange={(value) => { onChangeUnit(value); }}
                          multiple
                          placeholder={t('unidade')}
                          disabled={loading}
                        />
                      )
                    }
                    {
                      props.listFilters?.includes('users') && (
                        <FilterOption
                          value={state.selectedUsers}
                          options={state.usersFilterOpts}
                          onChange={(value) => { state.selectedUsers = value as any;
                            render();
                          }}
                          multiple
                          placeholder={t('usuario')}
                          disabled={loading}
                        />
                      )
                    }
                    {
                      props.listFilters?.includes('phone') && (
                        <PhoneInput
                          placeholder={t('telefone')}
                          value={state.selectedPhone}
                          onChange={(value) => { state.selectedPhone = formatPhone(value); render(); }}
                        />
                      )
                    }
                    {
                      (props.listFilters?.includes('contestation') && (
                        <ContentDate>
                          <DateLabel>{t('dataDaContestacao')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateContestation}
                            focused={state.selectFocusedDateContestation}
                            onFocusChange={({ focused }) => setState({ selectFocusedDateContestation: focused })}
                            onDateChange={(date) => {
                              state.selectedDateContestation = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      props.listFilters?.includes('statusHealth') && (
                        <FilterOption
                          value={state.selectedStatusHealth}
                          options={[
                            { value: 100, name: t('operandoCorretamente'), icon: <HealthIcon health="100" /> },
                            { value: 75, name: t('foraDeEspecificacao'), icon: <HealthIcon health="75" /> },
                            { value: 50, name: t('riscoIminente'), icon: <HealthIcon health="50" /> },
                            { value: 25, name: t('manutencaoUrgente'), icon: <HealthIcon health="25" /> },
                            { value: 2, name: t('equipamentoOffline'), icon: <HealthIcon health="2" /> },
                            { value: 4, name: t('maquinaDesativada'), icon: <HealthIcon health="4" /> },
                          ]}
                          onChange={(value) => {
                            state.selectedStatusHealth = value as any;
                            render();
                          }}
                          multiple
                          placeholder={t('status')}
                          disabled={loading}
                          renderOption
                        />
                      )
                    }
                    {
                      (props.listFilters?.includes('maintenance') && (
                        <FilterOption
                          value={state.selectedMaintenance}
                          options={[
                            { value: 1, name: t('sim') },
                            { value: 0, name: t('nao') },
                          ]}
                          onChange={(value) => {
                            state.selectedMaintenance = value as any;
                          }}
                          multiple
                          placeholder={t('manutencaoRealizada')}
                          disabled={loading}
                        />
                      ))
                    }
                    {
                      (props.listFilters?.includes('maintenanceDate') && (
                        <ContentDate>
                          <DateLabel>{t('dataDaManutencao')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateMaintenance}
                            focused={state.selectFocusedDateMaintenance}
                            onFocusChange={({ focused }) => setState({ selectFocusedDateMaintenance: focused })}
                            onDateChange={(date) => {
                              state.selectedDateMaintenance = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      props.listFilters?.includes('saude') && (
                        <FilterOption
                          options={state.faultsListOpts}
                          value={state.selectedFaultsOpts}
                          onChange={(value) => {
                            state.selectedFaultsOpts = value as any;
                            render();
                          }}
                          multiple
                          placeholder={t('saudeAtual')}
                          disabled={loading}
                        />
                      )
                    }
                    {
                      (props.listFilters?.includes('criticidadeAtual') && (
                        <FilterOption
                          value={state.selectedHealthOpts}
                          options={[
                            { value: 100, name: t('operandoCorretamente'), icon: <HealthIcon health="100" /> },
                            { value: 75, name: t('foraDeEspecificacao'), icon: <HealthIcon health="75" /> },
                            { value: 50, name: t('riscoIminente'), icon: <HealthIcon health="50" /> },
                            { value: 25, name: t('manutencaoUrgente'), icon: <HealthIcon health="25" /> },
                            { value: 2, name: t('equipamentoOffline'), icon: <HealthIcon health="2" /> },
                            { value: 4, name: t('maquinaDesativada'), icon: <HealthIcon health="4" /> },
                          ]}
                          onChange={(value) => {
                            state.selectedHealthOpts = value as any;
                            render();
                          }}
                          multiple
                          placeholder={t('criticidadeDaSaudeAtual')}
                          disabled={loading}
                          renderOption
                        />
                      ))
                    }
                    {
                      (props.listFilters?.includes('falhasDetectadas') && (
                        <FilterOption
                          options={state.faultsListOpts}
                          value={state.selectedFaultsDetected}
                          onChange={(value) => {
                            state.selectedFaultsDetected = value as any;
                            render();
                          }}
                          multiple
                          placeholder={t('falhasDetectadas')}
                          disabled={loading}
                        />
                      ))
                    }
                    {
                      (props.listFilters?.includes('falhasDetectadas') && state.selectedFaultsDetected?.length >= 1 && (
                        // render "only faults detected in all cycles" toogle only when there are faults selected
                        // TODO: remove this once there is an actual Machine Fault implemented
                        // this is just a workaround so that the R&D team can filter manual faults that affect all cycles in the machine
                        // since we already have faults that should only be detected if they are detected in ALL cycles of the machine
                        // but faults are detected by asset of a machine (i.e. we still don't have a proper Machine Fault implementation)
                        // this boolean is used in conjunction with filters.faultsDetected to fetch specific faults that affect all cycles of a machine
                        <ToggleSwitchMini
                          variant="default"
                          label="Em todos os ciclos"
                          checked={state.selectedOnlyFaultsDetectedInAllCycles}
                          onClick={(_) => {
                            setState({ selectedOnlyFaultsDetectedInAllCycles: !state.selectedOnlyFaultsDetectedInAllCycles });
                            render();
                          }}
                        />
                      ))
                    }
                    {
                      (props.listFilters?.includes('criticidadeFalhaDetectada') && (
                        <FilterOption
                          options={[
                            { value: 100, name: t('operandoCorretamente'), icon: <HealthIcon health="100" /> },
                            { value: 75, name: t('foraDeEspecificacao'), icon: <HealthIcon health="75" /> },
                            { value: 50, name: t('riscoIminente'), icon: <HealthIcon health="50" /> },
                            { value: 25, name: t('manutencaoUrgente'), icon: <HealthIcon health="25" /> },
                            { value: 2, name: t('equipamentoOffline'), icon: <HealthIcon health="2" /> },
                            { value: 4, name: t('maquinaDesativada'), icon: <HealthIcon health="4" /> },
                          ]}
                          value={state.selectedFaultCriticality}
                          onChange={(value) => { state.selectedFaultCriticality = value as any; render(); }}
                          multiple
                          placeholder={t('criticidadeDaFalhaDetectada')}
                          disabled={loading}
                          renderOption
                        />
                      ))
                    }
                    {
                      (props.listFilters?.includes('primeiroAlertaDe') && (
                        <ContentDate>
                          <DateLabel>{t('primeiroAlertaAPartirDe')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateStartFirstAlert}
                            focused={state.selectFocusedFirstAlert}
                            onFocusChange={({ focused }) => setState({ selectFocusedFirstAlert: focused })}
                            onDateChange={(date) => {
                              state.selectedDateStartFirstAlert = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      (props.listFilters?.includes('primeiroAlertaAte') && (
                        <ContentDate>
                          <DateLabel>{t('primeiroAlertaAte')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateEndFirstAlert}
                            focused={state.selectFocusedEndFirstAlert}
                            onFocusChange={({ focused }) => setState({ selectFocusedEndFirstAlert: focused })}
                            onDateChange={(date) => {
                              state.selectedDateEndFirstAlert = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      (props.listFilters?.includes('ultimaDeteccaoDe') && (
                        <ContentDate>
                          <DateLabel>{t('ultimaDeteccaoAPartirDe')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateStartLastAlert}
                            focused={state.selectFocusedStartLastAlert}
                            onFocusChange={({ focused }) => setState({ selectFocusedStartLastAlert: focused })}
                            onDateChange={(date) => {
                              state.selectedDateStartLastAlert = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      (props.listFilters?.includes('ultimaDeteccaoAte') && (
                        <ContentDate>
                          <DateLabel>{t('ultimaDeteccaoAte')}</DateLabel>
                          <SingleDatePicker
                            disabled={loading}
                            date={state.selectedDateEndLastAlert}
                            focused={state.selectFocusedEndLastAlert}
                            onFocusChange={({ focused }) => setState({ selectFocusedEndLastAlert: focused })}
                            onDateChange={(date) => {
                              state.selectedDateEndLastAlert = date; render();
                            }}
                            numberOfMonths={1}
                            displayFormat="DD/MM/YYYY"
                            isOutsideRange={(d) => !d.isBefore(state.tomorrow)}
                            placeholder={t('dd/mm/aaaa')}
                          />
                          <StyledCalendarIcon color={colors.brand.primary.dark} />
                        </ContentDate>
                      ))
                    }
                    {
                      (props.listFilters?.includes('status') && (
                        <FilterOption
                          options={[
                            { value: 'APPROVED', name: t('estadoDaFalhaOcorrenciaRatificada') },
                            { value: 'PENDING', name: t('estadoDaFalhaOcorrenciaPendente') },
                            { value: 'RESTABLISHED', name: t('estadoDaFalhaRestabelecimentoRatificado') },
                            { value: 'RESTAB_PENDING', name: t('estadoDaFalhaRestabelecimentoPendente') },
                          ]}
                          value={state.selectedFaultStates}
                          onChange={(value) => setState({ selectedFaultStates: value as any })}
                          multiple
                          placeholder={t('status')}
                          disabled={loading}
                        />
                      ))
                    }
                    {
                      props.listFilters?.includes('machines') && (
                        <FilterOption
                          options={state.machinesFilterOpts}
                          value={state.selectedMachinesIds}
                          onChange={(value) => { onChangeMachines(value); }}
                          multiple
                          placeholder={t('maquinas')}
                          disabled={loading || (!state.selectedClientOpts.length && !state.selectedUnitOpts.length) || state.machinesFilterOpts?.length === 0}
                        />
                      )
                    }
                    {
                      (props.listFilters?.includes('deviceId') && (
                        <SearchInputDevice>
                          <div>
                            <Label>{t('dispositivo')}</Label>
                            <ReactTags
                              tags={state.searchState}
                              handleDelete={(tag) => handleSearchDelete(tag)}
                              handleAddition={(tag) => handleSearchAddition(tag)}
                              delimiters={delimiters}
                              allowDragDrop={false}
                              allowDeleteFromEmptyInput={false}
                              inputFieldPosition="top"
                              minQueryLength={2}
                              placeholder=""
                            />
                          </div>
                          <IconWrapperSearch>
                            <SearchIcon width="13" height="13" />
                          </IconWrapperSearch>
                        </SearchInputDevice>
                      ))
                    }
                  </div>
                </div>
                <div style={{
                  display: 'flex',
                  alignItems: 'end',
                  marginTop: 'auto',
                  justifyContent: 'end',
                }}
                >
                  <Button
                    style={{
                      width: '150px',
                      marginLeft: '20px',
                      minWidth: '150px',
                      height: '41px',
                      textTransform: 'capitalize',
                      borderRadius: '4px',
                      marginBottom: '10px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    type="button"
                    variant="primary"
                    onClick={() => { setValues(); props.onAply(); render(); }}
                  >
                    {t('analisar')}
                  </Button>
                </div>
              </Flex>
            )
          }
        </FiltersContainer>
      ) : (
        <LoadingContainer>
          <Loader />
        </LoadingContainer>
      )}
    </Flex>
  );
};

interface SelectSearchOptionProps extends SelectSearchOption {
  icon?: ReactNode;
}

type FilterOptionProps = {
  value: string | string[] | boolean | undefined;
  placeholder: string;
  onChange: (
    selectedValue: SelectedOptionValue | SelectedOptionValue[],
    selectedOption: SelectedOption | SelectedOption[],
    optionSnapshot: SelectSearchProps
  ) => void;
  options: SelectSearchOptionProps[];
  disabled?: boolean;
  multiple?: boolean;
  closeOnSelected?: boolean;
  renderOption?: boolean;
  type?: string;
  getSelectedDate?: (opt: any, state: any) => any;
  setOnChange?: (opt: any, data: any) => void;
  state?: any;
  setState?: any;
  render?: any;
  removeMarginBottom?: boolean;
};

const FilterOption = (props: FilterOptionProps) => {
  function renderOption(propsRender, option, snapshot, className) {
    return (
      <button {...propsRender} className={className} type="button">
        <div
          style={{
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
          }}
        >
          {option.icon}
          <span style={{ marginLeft: '10px' }}>{option.name}</span>
        </div>
      </button>
    );
  }

  const handlePaste = (event: ClipboardEvent<HTMLDivElement>) => {
    event.preventDefault();
    const pastedData = event.clipboardData?.getData('text') ?? '';
    const pastedItems = pastedData
      .split(/[\n,;]+|\s{2,}/)
      .map((item) => item.trim())
      .filter(Boolean);

    if (pastedItems.length === 0) return;
    const matchedOptions = props.options.filter((opt) => {
      const valueStr = String(opt.value);
      return pastedItems.includes(opt.name) || pastedItems.includes(valueStr);
    });

    if (matchedOptions.length === 0) return;
    const matchedValues = matchedOptions.map((opt) => String(opt.value));

    let finalValues: any;
    if (props.multiple) {
      const current = Array.isArray(props.value) ? props.value : [];
      finalValues = Array.from(new Set([...current, ...matchedValues]));
    }
    else {
      finalValues = matchedValues[0];
    }
    const emptySelected = null as unknown as SelectedOption | SelectedOption[];
    const emptySnapshot = {} as SelectSearchProps;
    props.onChange(
      finalValues,
      emptySelected,
      emptySnapshot,
    );
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const normalizedValue = typeof props.value === 'boolean'
    ? (props.value ? 'true' : 'false')
    : props.value;

  return (
    <SearchInput
      disabled={props.disabled}
      style={{
        width: '226px',
        marginBottom: props.removeMarginBottom ? '0' : '10px',
        borderRadius: '8px',
        height: '41px',
        padding: '2px 0px',
      }}
      onPaste={handlePaste}
    >
      <ContainerArea>
        <Label style={{ opacity: props.disabled ? '0.4' : '1' }}>
          {props.placeholder}
        </Label>
        <SelectSearch
          options={props.options}
          value={normalizedValue}
          multiple={props.multiple}
          closeOnSelect={props.closeOnSelected}
          printOptions="on-focus"
          search
          filterOptions={fuzzySearch}
          placeholder={t('selecionar')}
          onChange={props.onChange}
          disabled={props.disabled}
          renderOption={props.renderOption ? renderOption : undefined}
        />
      </ContainerArea>
    </SearchInput>
  );
};

type PhoneInputProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  removeMarginBottom?: boolean;
};

export const PhoneInput = ({
  value,
  placeholder,
  onChange,
  disabled,
  removeMarginBottom,
}: PhoneInputProps) => (
  <SearchInput
    disabled={disabled}
    style={{
      width: '226px',
      marginBottom: removeMarginBottom ? '0' : '10px',
      borderRadius: '8px',
      height: '41px',
      padding: '2px 0px',
    }}
  >
    <ContainerArea>
      <Label style={{ opacity: disabled ? '0.4' : '1' }}>{placeholder}</Label>
      <input
        type="tel"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder="(00) 00000-0000"
        style={{
          width: '100%',
          border: 'none',
          outline: 'none',
          fontSize: '12px',
          marginLeft: '16px',
          marginRight: '16px',
          backgroundColor: 'transparent',
          color: disabled ? 'rgba(0,0,0,0.4)' : '#000',
        }}
      />
    </ContainerArea>
  </SearchInput>
);
